import w, { useState as A } from "react";
import e from "prop-types";
import { has as q, isArray as C, filter as E, includes as P } from "lodash";
import h from "memoize-one";
import { S as R, O as F, C as L } from "./index-BRV0FOnC.es.js";
import { f as I } from "./flattenOptions-BNos8vHQ.es.js";
import { w as v } from "./utils-C0l876fA.es.js";
const d = (t) => {
  const [i, c] = A(""), u = h((l, r, p) => r === "" ? l : l.map((o) => {
    const n = { ...o };
    return n.hidden = [
      o.label,
      ...o?.aliases || []
    ].every(
      (s) => !p(
        { ...n, label: s },
        i
      )
    ), q(o, "options") && C(o.options) && (n.options = u(
      n.options,
      i,
      p
    ), n.hidden = n.hidden && !n.options.find(
      (s) => !s.hidden
    ), n.hidden) ? null : n;
  }).filter((o) => o)), m = h(I), b = (l) => {
    t.onExpand(l), c("");
  }, T = (l) => {
    t.onSelect(l);
  }, O = (l) => {
    const { value: r } = l.target;
    c(r);
  }, { t: a } = t, g = {
    single: {
      focusPlaceholder: a("Filter..."),
      selectedFocusPlaceholder: a("Filter...")
    },
    multiple: {
      focusPlaceholder: a("Filter..."),
      selectedFocusPlaceholder: a("Add Another...")
    }
  }, x = u(
    t.options,
    i,
    t.filterOption
  ), f = m(t.options), S = t.selected.map((l) => f.find((r) => r.value === l).label).join(", "), y = E(
    f,
    (l) => P(t.selected, l.value)
  );
  return /* @__PURE__ */ w.createElement(
    R,
    {
      ...t,
      textInput: i,
      options: x,
      selectText: S,
      onSelect: T,
      onExpand: b,
      onTextInput: O,
      searchable: !0,
      alternateText: {
        ...g[t.multiple ? "multiple" : "single"],
        ...t.alternateText
      },
      chipOpts: y
    }
  );
};
d.propTypes = {
  /** The selectable options. See Option and Category objects below for details on possible keys/values. */
  options: e.arrayOf(
    e.oneOfType([
      F.isRequired,
      L.isRequired
    ])
  ).isRequired,
  /** The array of currently selected option values */
  selected: e.arrayOf(e.string).isRequired,
  /** Called when the expanded state should be changed to given boolean value */
  onExpand: e.func,
  /** Function called with new `selected` values when they change due to user interaction */
  onSelect: e.func.isRequired,
  /** Set to true to allow selection of multiple options */
  multiple: e.bool,
  /** function(option, textInput) -> boolean |
   * A case-insensitive function which returns true if option.label includes textInput |
   * A function to filter out the displayed options to the matching textInput.
   * This function is called for each option on render, and only renders the options
   * for which this function returns true.
   * */
  filterOption: e.func,
  /** An object for passing in text translations. See below for the full object of strings with defaults. */
  alternateText: e.objectOf(e.string),
  /** @ignore */
  t: e.func.isRequired,
  /** When true, text '(required)' will appear next to the label */
  required: e.bool,
  /** The label text shown above the Select.<br/>
   * <b>Required if `props.ariaLabelledBy` is not defined</b> */
  label: e.string,
  /** Set to true to disable interaction with the select */
  disabled: e.bool,
  /** When true, select will be displayed with 'dark' mode. */
  dark: e.bool,
  /** If true and multiple is true, chips will be displayed below the select for each selected option. */
  showChips: e.bool,
  /** Set to true to make dropdowns show all options without scrolling. */
  dropdownShowAll: e.bool,
  /** Set to true to highlight the select box when one of the dropdown options is selected. */
  highlightWhenOptionSelected: e.bool,
  /** the 'id' property to be passed to the select */
  id: e.string,
  /** HTML id of corresponding description for accessibility */
  ariaDescribedBy: e.string,
  /** HTML id of corresponding label for accessibility.<br/>
   * <b>Required if `props.label` is not defined.</b> */
  ariaLabelledBy: e.string,
  /** When this is specified, the text input renders with a red outline and displays this string in an error footer to prompt the user to correct the input. */
  error: e.string,
  /** When true, forces the clear all button to be shown, even if not a multi select */
  showClearAll: e.bool
};
d.defaultProps = {
  onExpand: () => null,
  multiple: !1,
  filterOption: (t, i) => t.label.toLowerCase().includes(i.toLowerCase()),
  alternateText: {},
  required: !1,
  label: null,
  disabled: !1,
  dark: !1,
  showChips: !1,
  dropdownShowAll: !1,
  highlightWhenOptionSelected: !1,
  id: null,
  ariaDescribedBy: null,
  ariaLabelledBy: null,
  error: null,
  showClearAll: !1
};
const W = v(d);
export {
  W as T
};
